import { TextBox, TextBoxChangeEvent } from "@progress/kendo-react-inputs";
import { CustomGridCellProps } from "../CustomGridCellProps";
import { ReadOnlyProps } from "../../../../Project/EditProject/ReadOnlyProps";

type Props = {
  uppercase: boolean;
};

export function TextBoxCell({
  dataItem,
  field,
  onChange,
  uppercase,
  isReadOnly,
}: CustomGridCellProps & Props & ReadOnlyProps) {
  const myField = field || "";
  const dataValue = uppercase ? (dataItem[myField] || "").toUpperCase() : dataItem[myField] || "";

  const handleChange = (e: TextBoxChangeEvent) => {
    if (onChange) {
      onChange({
        dataIndex: 0,
        dataItem,
        field,
        syntheticEvent: e.syntheticEvent,
        value: e.target.value,
      });
    }
  };

  return (
    <td>
      {dataItem.inEdit && !isReadOnly ? (
        <TextBox onChange={handleChange} value={dataValue} />
      ) : (
        dataValue
      )}
    </td>
  );
}
